<template>
  <div class="performance">
    <Skeleton width="120px" class="ml-18 mb-10" />
    <div class="performance_content">
      <span class="performance_content_title">
        <Skeleton width="90px" />
      </span>
      <strong class="performance_content_money">
        <Skeleton width="50px" />
      </strong>
    </div>
    <div class="performance_divider"></div>
    <div class="performance_content">
      <span class="performance_content_title">
        <Skeleton width="90px" />
      </span>
      <strong class="performance_content_money">
        <Skeleton width="50px" />
      </strong>
    </div>
    <div class="performance_divider"></div>
    <div class="performance_content">
      <span class="performance_content_title">
        <Skeleton width="90px" />
      </span>
      <strong class="performance_content_money">
        <Skeleton width="50px" />
      </strong>
    </div>
    <div class="performance_pay_waiting">
      <span class="performance_pay_waiting_title"
        ><Skeleton width="120px"
      /></span>
      <div class="performance_pay_waiting_description">
        <Skeleton width="280px" />
        <Skeleton width="280px" />
        <Skeleton width="280px" />
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from '@/components/Skeleton/Skeleton';

export default {
  name: 'ShopPerformanceSkeleton',
  components: {
    Skeleton,
  },
};
</script>

<style>
.ml-18 {
  margin-left: 18px;
}
</style>
